import React from 'react';
import PropTypes from 'prop-types';

import Link, { LinkProps as MuiLinkProps } from '@mui/material/Link';
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { ExternalLinkIcon } from '@classity-edtech/ui-base/dist/components/Displays';
import { globalColours } from '@classity-edtech/ui-base/dist/style/source';

export interface ExternalLinkProps extends MuiLinkProps {
  cta: string;
  href: string;
  icon: JSX.Element;
}

export const ExternalLink = ({ cta, icon, href, className, ...props }: ExternalLinkProps) => {
  return (
    <Link
      href={href}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
        cursor: 'pointer',
        color: globalColours['$global-colour-interactive-primary-default'],
        textDecoration: 'none',
        '&:hover': {
          textDecoration: 'underline',
          color: globalColours['$global-colour-interactive-control-hover'],
        },
      }}
      {...props}
    >
      {icon}
      <Typography variant='body3'> {cta}</Typography>
      <sup>
        <ExternalLinkIcon sx={{ width: '8px', height: '8px' }} />
      </sup>
    </Link>
  );
};

ExternalLink.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

ExternalLink.defaultProps = {
  children: null,
  className: null,
};

export default styled<any>(ExternalLink)(
  ({ theme }) => `
  & {
    .MuiPaper-root {
      display: flex;
      align-items: center;
      gap: 1;
      justify-content: space-between;
    }

    .error {
      background-color: ${theme.palette.error.main};
      color: ${theme.palette.secondary.contrastText};
    }

    .success {
      background-color: ${theme.palette.primary.main};
      color: ${theme.palette.secondary.contrastText};
    }

    .MuiSvgIcon-root {
      color: ${theme.palette.secondary.contrastText};
    }

    .MuiTypography-root {
      font-family: ${theme.typography.gillSans.regular};
    }
  }
`,
);
